import { post } from '../../../../api/baseUrl';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import type { RootState } from '../../../../store';

export const useGetHospitalAllClinicians = () => {
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [cliniciansByHospital, setCliniciansByHospital] = useState<any[]>([]);
  const { selectedTenancy } = useSelector(
    (state: RootState) => state.clinicianProfile,
  );

  const postGetHospitalAllClinicians = async (hospitalIds: number[]) => {
    setCliniciansByHospital([]);
    if (!selectedTenancy) return;
    setIsLoading(true);
    try {
      await Promise.all(
        hospitalIds.map(async (hospitalId) => {
          const payload = {
            clinicId: hospitalId,
            tenancyId: selectedTenancy.tenancy_id,
          };
          const { data } = await post(`getAllClinicians`, { ...payload });
          setCliniciansByHospital((acc: any[]) => {
            const curr = { clinicians: data.data, hospitalId };
            return [...acc, curr];
          });
        }),
      );
    } catch (error: any) {
      console.error('An error occurred during get cliniciansByHospital', error);
      setErrorMessage(
        error?.response?.data?.message ||
          'Unknown error in get cliniciansByHospital',
      );
    } finally {
      setIsLoading(false);
    }
  };

  return {
    postGetHospitalAllClinicians,
    errorMessage,
    isLoading,
    cliniciansByHospital,
  };
};
